var _excluded = ["fieldName", "id", "validation", "defaultValue", "onChange", "options", "placeholder", "disabled", "className", "wrapperClassName", "isClearable", "isSearchable", "multiple", "size", "required"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import SelectStyled from 'react-select';
import c from 'classnames';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { useExtendedFormikContext } from '../../FormikWrapper';
import getNestedFieldvalue from '../../getNestedFieldvalue';
import './style.scss';
var SelectInputOption = function SelectInputOption(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/no-danger
    React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: props.label
      }
    })
  );
};
var SelectInput = function SelectInput(props) {
  var fieldName = props.fieldName,
    id = props.id,
    validation = props.validation,
    defaultValue = props.defaultValue,
    _onChange = props.onChange,
    options = props.options,
    placeholder = props.placeholder,
    disabled = props.disabled,
    className = props.className,
    wrapperClassName = props.wrapperClassName,
    _props$isClearable = props.isClearable,
    isClearable = _props$isClearable === void 0 ? true : _props$isClearable,
    _props$isSearchable = props.isSearchable,
    isSearchable = _props$isSearchable === void 0 ? true : _props$isSearchable,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    size = props.size,
    required = props.required,
    restProps = _objectWithoutProperties(props, _excluded);
  var selectedOption = props.selectedOption;
  var _useExtendedFormikCon = useExtendedFormikContext(),
    values = _useExtendedFormikCon.values,
    setFieldValue = _useExtendedFormikCon.setFieldValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var value = getNestedFieldvalue(fieldName, values);

  // Check if options is [{value, label}] or {value: label}.
  var optionsTransformed = options;
  if (!Array.isArray(options)) {
    optionsTransformed = Object.keys(options).map(function (value) {
      var label = options[value];
      return {
        value: value,
        label: label
      };
    });
  }

  // If the selected option is not set, find the currently selected option by value.
  if (!selectedOption) {
    if (multiple) {
      var _value = value !== undefined ? value : defaultValue || [];
      selectedOption = optionsTransformed.filter(function (option) {
        return _value.includes(option.value);
      });
    } else {
      var _value2 = value !== undefined ? value : defaultValue || '';
      selectedOption = optionsTransformed.filter(function (option) {
        return option.value === _value2;
      });
    }
  }
  var handleValidation = function handleValidation(value) {
    if (validation) {
      return validation(value);
    }
    if (required && (value === undefined || value === null || value === '' || Array.isArray(value) && value.length === 0)) {
      return t(['webform.components.select.required', 'webform.required', 'webform_required']);
    }
  };
  return /*#__PURE__*/React.createElement(Field, {
    required: true,
    name: fieldName,
    value: value,
    validate: handleValidation
  }, function () {
    return /*#__PURE__*/React.createElement(SelectStyled, _extends({}, restProps, {
      id: id,
      inputId: fieldName,
      className: c('Select__select', className),
      classNamePrefix: "Select__inner",
      value: selectedOption,
      defaultValue: defaultValue,
      disabled: disabled,
      onChange: function onChange(e) {
        var value = '';
        if (e) {
          if (multiple) {
            value = e.map(function (item) {
              return item.value;
            });
          } else {
            value = e.value;
          }
        } else if (multiple) {
          value = [];
        }
        if (_onChange) {
          _onChange(value);
        }
        setFieldValue(fieldName, value);
      },
      options: optionsTransformed,
      isMulti: multiple,
      formatOptionLabel: SelectInputOption,
      isOptionDisabled: function isOptionDisabled(option) {
        if (option.disabled) {
          return true;
        }
        if (size && selectedOption.length >= size) {
          return true;
        }
        return false;
      },
      placeholder: placeholder,
      isClearable: isClearable,
      isSearchable: isSearchable,
      theme: {
        borderRadius: 0,
        colors: {
          danger: '#DE350B',
          dangerLight: '#FFBDAD',
          neutral0: 'hsl(0, 0%, 100%)',
          neutral10: 'hsl(0, 0%, 90%)',
          neutral20: 'hsl(0, 0%, 80%)',
          neutral30: 'hsl(0, 0%, 70%)',
          neutral40: 'hsl(0, 0%, 60%)',
          neutral5: 'hsl(0, 0%, 95%)',
          neutral50: 'hsl(0, 0%, 50%)',
          neutral60: 'hsl(0, 0%, 40%)',
          neutral70: 'hsl(0, 0%, 30%)',
          neutral80: 'hsl(0, 0%, 20%)',
          neutral90: 'hsl(0, 0%, 10%)',
          primary: '#f0694b',
          primary25: 'hsla(0,0%,0%, 0)',
          primary50: 'hsla(0,0%,0%, 0)',
          primary75: 'hsla(0,0%,0%, 0)'
        }
      }
    }));
  });
};
export default SelectInput;